import MuiTypography from '@mui/material/Typography';
import type { TypographyProps as MuiTypographyProps } from '@mui/material/Typography';
import type { SxProps } from '@mui/material/styles';

export type TypographyVariantOptions =
  | 'displayLarge'
  | 'displayLargeVariant'
  | 'displayMedium'
  | 'displayMediumVariant'
  | 'displaySmall'
  | 'headingLarge'
  | 'headingMedium'
  | 'headingSmall'
  | 'headingXSmall'
  | 'headingOverline'
  | 'titleLarge'
  | 'titleMedium'
  | 'bodyLarge'
  | 'bodyMedium'
  | 'bodySmall'
  | 'labelLarge'
  | 'labelSmall'
  | 'button'
  | 'trimmedXSmall'
  | 'trimmedSmall'
  | 'trimmedNormal'
  | 'trimmedMedium'
  | 'trimmedLarge'
  | 'monospacedXlarge'
  | 'monospacedLarge'
  | 'monospacedSmall'
  | 'none';

export interface TypographyPropsVariants {
  variant?: TypographyVariantOptions;
}
export interface TypographyProps
  extends Omit<MuiTypographyProps, 'variant'>,
    TypographyPropsVariants {
  weight?: 'regular' | 'bold';
  sx?: SxProps;
  children?: React.ReactNode;
  colorVariant?: 'default' | 'variant';
}

export const Typography = ({
  variant = 'bodySmall',
  sx,
  children,
  weight = 'regular',
  colorVariant = 'default',
  ...props
}: TypographyProps) => {
  return (
    <MuiTypography
      sx={{
        ...sx,
      }}
      {...props}
    >
      {children}
    </MuiTypography>
  );
};
